type Config = {
  link: string;
  name: string;
};

export enum FUEL {
  ElectricDE = 'Elektro',
  ElectricEN = 'Electric',
  PlugInHybrid = 'Plug-In-Hybrid',
}

export type Picture = {
  url: string;
  filename?: string;
  size?: number;
  type?: string;
};

export type Color = {
  color_hex: string;
  id: string;
  specific?: string;
};

export type VehicleBrand = {
  picture?: Picture;
  helper_brand_logo: Picture;
  id: string;
};

type VehicleDetails = {
  default_term: number;
  default_downpayment_term: number;
  related_configs?: number[];
  availability_by_term: Record<
    string,
    { available_from: string; available_to: string; deviation_in_weeks: number }
  >;
  product_desktop_sorting: number;
  co2emission: number;
  co2_class: string;
  uid: number;
  description: string;
  available_from: string;
  available_from_deviation_in_weeks?: number;
  availability: number;
  brand: VehicleBrand;
  cartype: CarType;
  color: Color;
  consumption: number;
  consumption_city?: number;
  consumption_highway?: number;
  earliest_expected_available_from?: string;
  equipment: Equipment;
  equipment_packages: Equipment;
  equipment_delimiter?: string;
  fuel: string;
  gearshift: string;
  id: string;
  product_label: ProductLabel;
  model: string;
  picture: Picture;
  pictures: Picture[];
  power: number;
  config?: Config;
  config_id: number;
  config_drive: string;
  engine: string;
  equipment_line: string;
  purchasing_deal_name: string;
  available_terms: number[];
  model_year: string;
  has_hitch: string;
  seats: string;
  doors: string;
  ev_range: string;
  tires: string;
  config_hitch: boolean | null;
  efficiency_class: string;
  efficiency_image: Picture;
  energy_class_file: { url: string };
  coming_soon?: boolean;
  trim_name?: string;
  available_to: string;
  color_list: VehicleColor[];
  financing_type: string;
  product_group: string[];
} & DeprecatedVehicleDetails;

type DeprecatedVehicleDetails = {
  has_real_pictures?: boolean;
  vehicle_identification_number?: string;
  delivery_options?: string;
  depreciation: number | null;
  gross_capitalized_cost?: number;
  indexable: true;
  product_path: string;
  offer_type: 'subscription';
  available_states?: string[];
  product_stock_preorder: number | null;
  source: string;
  states_stock: null;
  product_stock_total: number | null;
  product_stock_webflow: number | null;
  recurrent_payment_method_list: ['stripe_credit_card', 'stripe_debit_sepa'];
  residual_values: null;
  seo_canonical_product_id: null;
  single_payment_method_list: ['stripe_credit_card', 'stripe_debit_sepa'];
};

export type GenericVehicleDetails = {
  price: { available_price_list: Price } & Price;
  downpayment_prices: DownpaymentPrices & Price;
} & VehicleDetails;

type B2BPrice = {
  gross_list_price: number;
  has_b2b_deals?: boolean;
  discount_percentage?: number;
  fixed_amount?: number;
  available_price_list: { [key: string]: number | null };
  [key: string]: unknown;
};

export type B2BVehicleDetails = VehicleDetails & {
  default_term: number;
  cheapestTerm: number;
  default_downpayment_term: number;
  price: B2BPrice;
  downpayment_prices: B2BPrice;
  b2b_labels?: string[];
};

type ProductLabel = {
  label: string | null;
  label_color: string | null;
  label_inverted: string | null;
  label_text_color: string | null;
};

type Equipment = {
  [key: string]: string;
};

export type Price = {
  [key: string]: number;
};

export type DownpaymentPrices = {
  downpayment_discount_percentage: number;
  downpayment_fixed_amount: number;
  available_price_list: { [key: string]: number | null };
  extra_km_price: number;
  msrp: number;
};

export type VehiclesResponse = {
  offset?: number;
  results: GenericVehicleDetails[];
  total_results: number;
};

export type CarType = 'SUV' | 'Kleinwagen' | 'Kombi' | 'Van';

export type Thumbnail = {
  height: number;
  url: string;
  width: number;
};

export type VehicleColor = {
  car_id: string;
  color_hex: string;
  id: string;
  availability: number;
  desktop_sorting: number;
  availability_date?: string | null;
  brand: string;
  model: string;
  color_specific: string;
  picture_front_url?: string;
  pricing: number[];
  sorting: string;
  uid: number;
};
